import React, { useEffect, useRef, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { FileUpload } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import performanceManagementService from "@services/performanceManagement.service";
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { BlockUI } from 'primereact/blockui';

export default function ReportRepo() {
  const toast = useRef(null);
  const [blocked, setBlocked] = useState(false);

  const fileUploader = useRef(null);
  const uploadhandler = (e) => {

    if (selectedReport) {

      setBlocked(true);
      const formData = new FormData();
      e.files.forEach(file => {
        formData.append("files", file);
      });
      formData.append("reportType", selectedReport.code);
      performanceManagementService.importReports(formData).then((response) => {
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Success' });
        setUpdate(!update);
        fileUploader.current.clear();
        setBlocked(false);
        // console.log(fileUploader);
      }).catch((err) => {
        console.log(err);
        toast.current.show({ severity: 'error', summary: 'error', detail: err.message });
        setBlocked(false);
      })
    }
    else {
      toast.current.show({ severity: 'error', summary: 'error', detail: 'Select report type' });
      setBlocked(false);
    }

  };
  const [selectedReport, setSelectedReport] = useState(null);
  const [update, setUpdate] = useState(true);
  const reports = [
    { name: 'Site', code: 'site' },
    { name: '3G Reports', code: '3g' },
    { name: '4G Reports', code: '4g' },
    { name: 'Post Process', code: 'pp' },
    { name: 'CTO', code: 'CTO' },
    { name: 'Adhoc', code: 'Adhoc' },
    { name: 'Cluster DT report', code: 'Cluster_DT_report' },
  ];
  const [reportsList, setReportsList] = useState([]);

  useEffect(() => {
    performanceManagementService.reportsList().then((response) => {
      // console.write(response.data);
      setReportsList(response.data);
      // console.log(reportsList);

    }).catch((err) => {
      // toast.current.show({ severity: 'error', summary: 'error', detail: 'Upload Fails' });
    })
  }, [update]);
  useEffect(() => {
    setUpdate(!update);
  }, []);
  const onDeleteReport = (row) => {
    performanceManagementService.reportsDelete({ id: row._id }).then((response) => {
      toast.current.show({ severity: 'info', summary: 'Info', detail: 'Success' });
      setUpdate(!update);
    }).catch((err) => {
      toast.current.show({ severity: 'error', summary: 'error', detail: 'Delete Fails' });
    })
  }
  const onDownload = (row) => {
    setBlocked(true);
    performanceManagementService.reportsDownload({ id: row._id }).then((response) => {
      const href = URL.createObjectURL(new Blob([response.data]));

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', row.name); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      setBlocked(false);
    }).catch((err) => {
      toast.current.show({ severity: 'error', summary: 'error', detail: 'Download Fails' });
      setBlocked(false);
    })
  }
  const exportTemplateDownload = (rowData) => {
    return (
      <Button icon="pi pi-download" label="Download" onClick={() => onDownload(rowData)} size="small" />
    );
  };
  const exportTemplate = (rowData) => {
    return (
      <Button icon="pi pi-times" onClick={() => onDeleteReport(rowData)} className="p-button-rounded p-button-danger p-button-text" />
    );
  };
  return (<div className="card">
    <BlockUI blocked={blocked}>
      <TabView className="m-4">
        {
          reports.map((p) => {
            console.log(p.code, reportsList);

            console.log(p.code, reportsList.filter(p => p.reportType === p.code));
            return (
              <TabPanel key={p.code} className="mr-2 ml-2" header={p.name}>
                <DataTable value={reportsList.filter(q => q.reportType === p.code)} tableStyle={{ minWidth: '50rem' }}>
                  <Column body={exportTemplate}  ></Column>
                  <Column field="name" header="Name"></Column>
                  <Column field="size" header="Size"></Column>
                  <Column field="user" header="User"></Column>
                  <Column field="date" header="Date"></Column>
                  <Column body={exportTemplateDownload}  ></Column>
                </DataTable>
              </TabPanel>
            )
          })
        }


        <TabPanel leftIcon="pi pi-cloud-upload mr-2" className="mr-2 ml-2" header="Upload"><div className="card flex justify-content-center">
          <Dropdown value={selectedReport} onChange={(e) => setSelectedReport(e.value)} options={reports} optionLabel="name"
            placeholder="Select a category" className="w-full md:w-14rem m-4" /></div>
          <FileUpload ref={fileUploader} name="demo[]" multiple customUpload uploadHandler={uploadhandler} maxFileSize={150000000} accept=".zip,.rar" emptyTemplate={<p className="m-0">Just Zip or RAR accepted</p>} />
        </TabPanel>
      </TabView></BlockUI>
    <Toast ref={toast} />
  </div>);
}
